import { Control, Field, Input } from "@allxsmith/bestax-bulma";
import React from "react";
import useInlineEditButton from "./useInlineEditButton";

function useEditableTableNumberCell({
  propName,
  value,
  onChange,
  onSave,
  editable,
  setEditable,
  inlineEdit,
  replaceInput,
  disabled
}) {
  return (
    <td onClick={e => e.stopPropagation()}>
      <Field className="has-addons">
        <Control>
          {replaceInput ? replaceInput :
            <Input
              className="small-row-black"
              onChange={onChange}
              type="number"
              name={propName}
              value={value}
              disabled={!editable}
            />
          }
        </Control>
        {useInlineEditButton({show: inlineEdit, onSave, setEditable, editable, disabled})}
      </Field>
    </td>
  );
}

export default useEditableTableNumberCell;
